import { render, staticRenderFns } from "./editBlacklistedCandidate.vue?vue&type=template&id=53f084a3&"
import script from "./editBlacklistedCandidate.vue?vue&type=script&lang=js&"
export * from "./editBlacklistedCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports